import Review, { getDefaults as getReviewDefaults, ReviewOptions, ReviewType } from 'models/Review';

export interface SafeReturnOptions extends ReviewOptions {
  type: ReviewType.SAFE_RETURN;
}

export function getDefaults(): SafeReturnOptions {
  const defaults = getReviewDefaults();
  return {
    ...defaults,
    type: ReviewType.SAFE_RETURN,
  };
}

export default class SafeReturn extends Review {
  declare type: ReviewType.SAFE_RETURN;

  constructor(options: Partial<SafeReturnOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);
  }

  static get type() {
    return ReviewType.SAFE_RETURN;
  }

  get acknowledged() {
    return !this.active;
  }
}
